module.exports = __webpack_public_path__ + "static/media/bigCommerce.9fa40241.svg";